export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11096.789f4639.jpg";